import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { LoginService } from '../login/login.service';

@Injectable({
    providedIn: 'root',
})
export class ProfileCompleteGuard {
    constructor(
        private _loginService: LoginService,
        private _router: Router,
    ) {}

    canActivate(
        _route: ActivatedRouteSnapshot,
        _state: RouterStateSnapshot,
    ): boolean | UrlTree {
        return this.check();
    }

    canActivateChild(
        _childRoute: ActivatedRouteSnapshot,
        _state: RouterStateSnapshot,
    ): boolean | UrlTree {
        return this.check();
    }

    private check(): boolean | UrlTree {
        const info = this._loginService.userInfo;
        if (info.type === 'student' && info.studentInfo?.profileComplete === false) {
            return this._router.createUrlTree(['/complete-profile']);
        }
        return true;
    }
}
